export const COLOR = {
  BUTTON_BACKGROUND: "#aaa",
  GAME_BACKGROUND: "rgb(178 207 215)",
  PANTS: "#000",
  SKIN: "#f9dbc0",
  DARK_SKIN: "#f6b26b",
  HAIR: "744700",
  SHOES: "#555",
  STRETCHED: "coral",
  HP_ONE_HAND: "tomato",
  HP_TWO_HAND: "#33c",
  HP_UNSTABLE: "goldenrod",
  HP_RISKY: "darkred",
};

export const SIZE = {
  INPUT_WIDTH: 220,
  GAME_WIDTH: 950,
  GAME_HEIGHT: 780,
};

export const BODY = {
  WIDTH: 33,
  HEIGHT: 60,
  SHOULDER_GAP: 0,
  COXA_GAP: 6,
};

export const TIME_LIMIT = 300;
